import { przezmorzeApi, throwMessageOnStatuses } from "../../api/api";
import type {
  CropArea,
  CropMediaImageRequest,
  MediaImage,
  MediaImageListResponse,
  UpdateMediaImageRequest,
} from "@przezmorze/api-types";

export type { CropArea, MediaImage, UpdateMediaImageRequest };

export async function listImages(abortSignal?: AbortSignal) {
  const response = await przezmorzeApi.get<MediaImageListResponse>("/media/images", { signal: abortSignal });
  return response.data.items;
}

export async function uploadImage(body: FormData, abortSignal?: AbortSignal) {
  const response = await przezmorzeApi.post<MediaImage>("/media/images", body, {
    signal: abortSignal,
    timeout: 120_000,
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
  return response.data;
}

export async function updateImage(imageId: string, body: UpdateMediaImageRequest, abortSignal?: AbortSignal) {
  const response = await przezmorzeApi.put<MediaImage>(`/media/images/${imageId}`, body, {
    signal: abortSignal,
    timeout: 120_000,
  });
  return response.data;
}

export async function cropImage(imageId: string, body: CropMediaImageRequest, abortSignal?: AbortSignal) {
  try {
    const response = await przezmorzeApi.post<MediaImage>(`/media/images/${imageId}/crop`, body, {
      signal: abortSignal,
      timeout: 120_000,
    });
    return response.data;
  } catch (error) {
    throwMessageOnStatuses(error, [400, 404]);
  }
}

export async function deleteImage(imageId: string, abortSignal?: AbortSignal) {
  await przezmorzeApi.delete<void>(`/media/images/${imageId}`, {
    signal: abortSignal,
  });
}
